var Raven = require('imports?this=>window!raven-js');

module.exports = Raven;



// WEBPACK FOOTER //
// ./app/Raven.js